// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-con{
    width: 100%;
    background-color: white;
    border-radius: 9px;
    margin-top: 16px;
    height: 550px;
    padding: 25px 30px;
}

.change-password-con .lock-icon{
background-color: #f8fbff;
width: 45px;
height: 45px;
border-radius: 50%;
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 10px;
}

.change-password-con .lock-icon img {
    width: 24px;
    height: 24px;

}

.change-password-con .titles h2{
    font-size: 19px;
}
.change-password-con .titles p{
    color: #788393;
    font-size: 12px;
    font-weight: 600;
    
}

.change-password-con .row .left img{
    width: 18px;
    height: 18px;
}

.change-password-con .row{
    margin-top: 10px;
}

.change-password-con .row label {
    font-weight: 700;
    font-size: 14px;
}

.change-password-con .row .input-field{
    border: 1px solid #e7eaf1;
    width: 320px;
    max-width: 100%;
    border-radius: 7px;
    padding: 3px 10px;
    margin-top: 8px;
}

.change-password-con .row .input-field svg{
    margin: 0px 5px;
    color: #495c77;
}

.change-password-con .row .input-field input{
    background-color: none;
    border: none;
    margin: 0px 3px;
    color: #495c77;
    width: 265px;
    max-width: 100%;
}

.change-password-con .row .input-field input::placeholder{
    font-size: 12px;
    color: #495c77;
}

.change-password-con .row .input-field input:focus{
    outline: none;
}

.change-password-con  .submit-btn{
    width: 320px;
    color: white;
    text-align: center;
    padding: 11px 22px;
    border-radius: 7px;
    background-color: var(--main-color);
    border: none;
    font-size: 12px;
    margin-top: 20px;
    font-weight: 600;
    transition: var(--main-transition);
}

.change-password-con .err-msg{
    color: #d32f2f  ;
    font-size: 11px;
    visibility: hidden;
}

.change-password-con .err-msg-show{
    visibility: visible;
}

.change-password-con  .submit-btn:hover{
    opacity: .8;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Pages/changePassword/changepassword.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".change-password-con{\n    width: 100%;\n    background-color: white;\n    border-radius: 9px;\n    margin-top: 16px;\n    height: 550px;\n    padding: 25px 30px;\n}\n\n.change-password-con .lock-icon{\nbackground-color: #f8fbff;\nwidth: 45px;\nheight: 45px;\nborder-radius: 50%;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nmargin-bottom: 10px;\n}\n\n.change-password-con .lock-icon img {\n    width: 24px;\n    height: 24px;\n\n}\n\n.change-password-con .titles h2{\n    font-size: 19px;\n}\n.change-password-con .titles p{\n    color: #788393;\n    font-size: 12px;\n    font-weight: 600;\n    \n}\n\n.change-password-con .row .left img{\n    width: 18px;\n    height: 18px;\n}\n\n.change-password-con .row{\n    margin-top: 10px;\n}\n\n.change-password-con .row label {\n    font-weight: 700;\n    font-size: 14px;\n}\n\n.change-password-con .row .input-field{\n    border: 1px solid #e7eaf1;\n    width: 320px;\n    max-width: 100%;\n    border-radius: 7px;\n    padding: 3px 10px;\n    margin-top: 8px;\n}\n\n.change-password-con .row .input-field svg{\n    margin: 0px 5px;\n    color: #495c77;\n}\n\n.change-password-con .row .input-field input{\n    background-color: none;\n    border: none;\n    margin: 0px 3px;\n    color: #495c77;\n    width: 265px;\n    max-width: 100%;\n}\n\n.change-password-con .row .input-field input::placeholder{\n    font-size: 12px;\n    color: #495c77;\n}\n\n.change-password-con .row .input-field input:focus{\n    outline: none;\n}\n\n.change-password-con  .submit-btn{\n    width: 320px;\n    color: white;\n    text-align: center;\n    padding: 11px 22px;\n    border-radius: 7px;\n    background-color: var(--main-color);\n    border: none;\n    font-size: 12px;\n    margin-top: 20px;\n    font-weight: 600;\n    transition: var(--main-transition);\n}\n\n.change-password-con .err-msg{\n    color: #d32f2f  ;\n    font-size: 11px;\n    visibility: hidden;\n}\n\n.change-password-con .err-msg-show{\n    visibility: visible;\n}\n\n.change-password-con  .submit-btn:hover{\n    opacity: .8;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
